import React, { useEffect } from 'react';

// Lightweight modal for expanding report cards to 90% viewport
export default function ReportExpandModal({ open, title, onClose, children }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('report-modal-overlay')) onClose?.();
  };

  return (
    <div className="report-modal-overlay" role="dialog" aria-modal="true" onClick={handleOverlayClick}>
      <div className="report-modal">
        <div className="modal-head">
          <h2 style={{ margin: 0, fontSize: '1rem' }}>{title}</h2>
          <button className="modal-close" onClick={() => onClose?.()} aria-label="Close">✕</button>
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
}

